import {
  Component,
  ElementRef,
  AfterViewInit,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  TemplateRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { filter, takeUntil } from 'rxjs/operators';
import { MarketplaceProfileComponent } from 'src/app/customers/layout/component-layout/marketplace-profile/marketplace-profile.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SignInComponent } from '../component-layout/sign-in/sign-in.component';
import { ShepherdService } from 'angular-shepherd';
import {
  getStepsAddProduct,
  stepsVerifyEmail,
  stepsSuggestionProduct,
  stepsProfile,
  stepsFavoritesProduct,
  stepsCreateNews,
  defaultStepOptions,
} from './data-shepherd';
import { CommunityProduct } from 'src/app/shareModule/models/community-product.model';
import { select, Store } from '@ngrx/store';
import { loadAllCommunityProducts } from 'src/app/shareModule/states/community-product';
import { Subject, Subscription, timer } from 'rxjs';
import { ChatbotService } from '../../../shareModule/component/chat/chatbot/chatbot.service';
import { isPlatformBrowser, Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { loadUser, selectUser } from 'src/app/shareModule/states/user-details';
import { AppState } from 'src/app/shareModule/states/app.state';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { environment } from 'src/environments/environment';
import { SideLeftMenuComponent } from '../component-layout/side-left-menu/side-left-menu.component';
import { MenuOptionsComponent } from './menu-options/menu-options.component';
import { User } from 'src/app/shareModule/models/user.model';
import { RecommendationsFormComponent } from '../../community/recommandations-form/recommandations-form.component';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { SitePromoPopupComponent } from 'src/app/site-promo-popup/site-promo-popup.component';
import { CustomizationComponent } from '../component-layout/customization/customization.component';

@Component({
  selector: 'app-customers-layout',
  templateUrl: './customers-layout.component.html',
  styleUrls: ['./customers-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomersLayoutComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private destroy$ = new Subject<void>();
  @ViewChild('SignIn', { static: false }) signIn: SignInComponent;
  @ViewChild('MarketplaceProfile')
  marketplaceProfileSection: MarketplaceProfileComponent;

  @ViewChild('menuOptions') menuOptions: MenuOptionsComponent;

  public navbarVisible: boolean = true;
  public navbarScroll: boolean = true;
  public mobilePopUpTimer = null;
  public isUserLogin: any = 0;
  public currentMenu: any = '';
  public mobileAds = [];

  ///////////////////
  public messageAtTop = '';
  private fetchMessageAtTop() {
    this.auth.getSiteInfo('MESSAGE_AT_TOP').subscribe({
      error: console.error,
      next: (data: any) => (this.messageAtTop = data?.data?.value),
    });
  }

  //////////////////

  public openOptionalRecommModal() {
    const ref = this.modalService.open(RecommendationsFormComponent, {
      size: 'md',
    });

    ref.componentInstance.pollId = this.surveyData.poll.id;
    const subregion = this.commonService.subRegionLists.find(
      (sub) => sub.subRegionId == this.local.getUser()?.region
    );
    ref.componentInstance.selectedRecommTypeIndex = 0;
    ref.componentInstance.selectedSubRegion = subregion;
    ref.componentInstance.onlyVisibleInfos = ['region', 'companyName', 'name'];
  }
  public closeWizardPermanently() {
    this.isWizardVisisble = false;
    this.surveyData.isOpen = false;
    this.cdr.detectChanges();
  }
  public setSurveyCat(cat) {
    this.surveyData.page = 2;
    this.selectedCat = cat;
    this.cdr.detectChanges();
  }
  public setSurveySubCat(subcat) {
    ///set tag here but also need a way to choose poll form
    // also filter same subregion
    this.surveyData.page = 3;
    this.surveyData.selectedSubCat = subcat;
    console.log({ subcat });
    console.log('showing poll');
    this.auth
      .poll_fetch({
        isAll: false,
        productId: null,
        fetchCategoryOnly: false,
        categoryId: subcat?.categorieChildId,
        subRegionId: this.local.getUser()?.region,
      })
      .subscribe({
        next: (data: any) => {
          console.log('poll data', data);
          this.surveyData.poll = data.body.data[0];
          console.log('poll=', this.surveyData.poll);
          if (!this.surveyData.poll) {
            this.surveyData.page = 4;
          }

          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }
  public subcatsWithPoll = [];
  public pollSelectedProduct = null;
  public setPollSelected(productName) {
    this.pollSelectedProduct = { name: 'Loading...' };
    this.auth.getMemberShopProductByName(productName).subscribe({
      next: (data) => {
        this.pollSelectedProduct = data.body;
        this.cdr.detectChanges();
      },
    });
  }

  public storeAffordableData(ans) {
    this.auth.addAfforableScore(this.pollSelectedProduct?.id, ans).subscribe({
      next: () => {
        this.pollSelectedProduct = null;
        this.cdr.detectChanges();
      },
    });
  }
  public openPollForm() {
    this.auth
      .poll_fetch({ isAll: false, productId: null, fetchCategoryOnly: true })
      .subscribe({
        next: (data: any) => {
          this.subcatsWithPoll = data.body.data;
          if (this.subcatsWithPoll?.length == 0) {
            this.surveyData.page = -1; //go to thank you
            return;
          }
          this.surveyData.page = 2;
          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }
  // public delightsCat = null
  public selectedCat = null;
  public categories = [];
  private _fetchSurveyInfos() {
    // this.delightsCat = this.commonService.subCategoryList.find(cat => cat.name?.toLowerCase()?.include('local delights'))
    this.commonService.categoryList.subscribe((response: any) => {
      this.categories = structuredClone(response);
      this.cdr.detectChanges();
    });
    // console.log('delight', this.delightsCat, )
    this.auth.getAssignedPointRewards().subscribe({
      next: (data) => {
        this.surveyData.recommPayAmmount =
          data.body.find((tple) => tple.action == 'POLL_REWARD')?.reward ?? 0;
        this.cdr.detectChanges();
      },
      error: console.log,
    });
  }
  public setComparableChoice(ans) {
    if (ans == 'Yes') {
      this.surveyData.askQualityQn = true;
      this.surveyData.poll.industryStandard = '';
    } else {
      this.surveyData = null;
    }
  }

  public surveyData = {
    isOpen: false,
    page: 0,
    selectedCat: '',
    poll: null,
    askQualityQn: false,
    recommPayAmmount: 0,
    selectedSubCat: null,
  };
  private _openSurvey({ page = 0, selectedSubCat = null, poll = {} } = {}) {
    this.surveyData.isOpen = true;
    this.surveyData.page = page;
    this.surveyData.selectedSubCat = selectedSubCat;
    this.surveyData.poll = poll;
    this.isWizardVisisble = true;
    this.cdr.detectChanges();
  }

  // public goToPoll(selectedCat){
  //   this.surveyData.page = 1;
  //   this.surveyData.selectedCat = selectedCat;
  //   console.log(selectedCat, this.delightsCat)
  //   if(selectedCat?.id == this.delightsCat.id){
  //     this.openPollForm()

  //   }else{
  //     console.log('hiding wizard')

  //     this.surveyData.isOpen = false;
  //     this.isWizardVisisble = false;

  //   }
  // }

  private _promptNickName(data) {
    Swal.fire({
      title: 'Missing Nickname',
      text: 'Please Enter A Profile Nick Name',
      icon: 'info',
      showCancelButton: false,
      confirmButtonColor: 'var(--primary)',
      input: 'text',
      //type: "input",
      //closeOnConfirm: false,
      // animation: "slide-from-top",
      inputPlaceholder: 'Write something',
      confirmButtonText: 'Done',
    }).then((res) => {
      if (!res.value) {
        this.toastr.error('Invalid value!');
        this._promptNickName(data);
        return;
      }
      const formData = new FormData();

      Object.keys(data).map((row) => {
        if (typeof data[row] === 'boolean') {
          formData.append(row, data[row] ? '1' : '0');
        } else {
          formData.append(row, data[row]);
        }
      });
      formData.delete('profileCharacterName');
      formData.delete('postalCode');
      formData.append('profileCharacterName', res.value);
      res.value;
      this.auth.updateProfileCharacterDetails(formData).subscribe({
        next: () => {
          this.toastr.success('Changed!');
          this._openSurvey();
        },
        error: (err) => {
          console.error(err);
          this._promptNickName(data);
          this.toastr.error(err.error.message);
        },
      });
    });
  }
  public surveyOpenEndenAnswer = '';
  public storeQualityAns(comparableAns) {
    this.auth
      .addOpenEndedAnswer({ pollId: this.surveyData?.poll?.id, comparableAns })
      .subscribe({
        next: () => {
          this.surveyData.poll.industryStandard = '';
          this.surveyData.askQualityQn = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.surveyData.poll.industryStandard = '';
        },
      });
  }
  public giveReward() {
    this.auth
      .givePollReward(this.surveyData?.poll?.id)
      .subscribe({ error: console.error });
  }
  public storeOpenEndedQn() {
    this.auth
      .addOpenEndedAnswer({
        pollId: this.surveyData?.poll?.id,
        answer: this.surveyOpenEndenAnswer,
      })
      .subscribe({
        next: () => {
          this.surveyData.poll.openEndedQuestion = '';
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.surveyData.poll.openEndedQuestion = '';
          this.cdr.detectChanges();
        },
      });
  }
  private _checkIfUserHasProfileCharacterName() {
    this._fetchSurveyInfos();
    //  this._openSurvey();
    //console.log('checking if user has profile character name')
    const user = this.local.getUser();
    if (user) {
      console.log('user has logged in');
      this.store.dispatch(loadUser({}));
      this.store
        .pipe(select(selectUser))
        .pipe(filter((user) => !!user))
        .subscribe((data: User) => {
          if (this.sharedService.isBrowser()) {
            this.commonService.setTheme(data.theme);
            console.log('user theme#2 is', data.theme);
            this.cdr.markForCheck();
          }

          timer(5000).subscribe(() => {
            if (!data.profileCharacterName) {
              //console.log('user has no character name')
              this._promptNickName(data);
            } else {
              //console.log('user has character name', data.profileCharacterName)
            }
          });
        });
    } else {
      // console.log('user has not logged in')
    }
  }

  //////////////////////

  private lastScrollTop = 0;
  submitted = false;

  appUserId: any = 0;
  referralCode: any;
  menuSliderLeft = false;
  sloganText: string = 'We Recommend the Good Stuff';
  isNewMessage: boolean = false;
  customerService: boolean = false;
  isReferralLink: boolean = false;
  imgUrl: string = environment.ImageUrl;
  profileAvatar: string;

  //PLEASE ACCEPT THIS CHANGE
  totalUnreadMessagesCount = 0;
  tabMenu: number = 0;
  constructor(
    public auth: AuthServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private memberNotificationService: MemberNotificationService,
    public sharedService: SharedService,
    public roleService: RoleService,
    private shepherdService: ShepherdService,
    private store: Store<AppState>,
    private chatbotService: ChatbotService,
    private location: Location,
    private notificationService: MemberNotificationService,
    public commonService: CommonService,
    private seoService: SeoService,
    private cdr: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    //PLEASE ACCEPT THIS CHANGE
    this.totalUnreadMessagesCount =
      chatbotService.getTotalUnreadMessagesCount();
    chatbotService.chatTotalUnreadCount$.subscribe((data) => {
      this.totalUnreadMessagesCount = data;
    });
    this.sharedService.chatNowSubject.subscribe((response: any) => {
      this.openProfilePopup(response?.menu);
    });
  }
  public get areThereNewMessages(): boolean {
    return this.totalUnreadMessagesCount > 0;
  }

  /************************ Code related to browse hover ************************************/
  public areBrowserChildrenShowing = false;
  public ClickCate = false;
  public ClickSubCate = false;
  // public browseMouseIn(event){
  //   this.areBrowserChildrenShowing = true;
  // }
  // public browseMouseOut(event){
  //   this.areBrowserChildrenShowing = false;
  // }
  public closeBrowse() {
    this.areBrowserChildrenShowing = false;
    this.currentTypesList = [];
  }
  public relationShips = [];
  public browseSelectedMainCategory = null;
  public selectedSubCategory = null;
  private _getRelationShips() {
    this.commonService.categoryList.subscribe((categories) => {
      this.relationShips = structuredClone(categories);
      for (const cat of this.relationShips) {
        if (cat.subCategory) {
          //console.log({cat})
          for (const subcat of cat.subCategory) {
            this.relationShips.push(subcat);
          }
        }
      }
    });
  }
  @ViewChild('levelUpPopup') leveledUp: TemplateRef<any>;

  public currentLevel = 0;
  private _setupLevelChangeModalSubscription() {
    this.notificationService.notificationList
      .pipe(takeUntil(this.destroy$))
      .subscribe((notifs: any) => {
        const levelUpNotif = notifs.find(
          (notif) => !notif.isRead && notif.type == 'leveledUp'
        );
        if (levelUpNotif) {
          const payload = JSON.parse(levelUpNotif.payload);
          this.currentLevel = payload.newLevel;

          this.auth
            .makeAllNotificationsOfUserSeen()
            .subscribe({ error: console.error });
          this.modalDismissAll();
          this.openLevelUpPopup(this.leveledUp);
        }
      });
  }

  private modalRef?: MatBottomSheetRef | NgbModalRef = null;
  public openRecommendForm() {
    if (this.sharedService.isOnMobile) {
      this.modalRef = this.bottomSheet.open(RecommendationsFormComponent, {
        panelClass: 'bottom-sheet-1',
        hasBackdrop: true,
      });
      this.modalRef.instance.activeModal = this.modalRef;
    } else {
      this.modalRef = this.modalService.open(RecommendationsFormComponent);
    }
  }
  public selectedSubCatSlug = null;
  public currentTypesList = [];
  public areTypesLoading = false;
  public browserMakeMainCategory(cat) {
    this.currentTypesList = [];
    this.browseSelectedMainCategory = cat.id;
  }
  public showTypesOf(cat, goToPage = true) {
    this.selectedSubCategory = cat.id;
    this.selectedSubCatSlug = cat.catSlug;
    this.currentTypesList = [];
    this.areTypesLoading = true;
    this.auth.getTypesOfCategory(cat.categorieChildId).subscribe({
      next: (data: any) => {
        this.currentTypesList = data.data;
        if (goToPage) {
          //&& !this.currentTypesList.length
          // this.areBrowserChildrenShowing = false;
          this.router.navigateByUrl('/category/' + cat.catSlug);
        }
        this.areTypesLoading = false;

        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error(err);
        this.areTypesLoading = false;
        this.router.navigateByUrl('/category/' + cat.catSlug); //just in case
        this.areBrowserChildrenShowing = false;
      },
    });
  }
  /**************************************************************************************** */

  public backToSearch(event) {
    event.preventDefault();
    this.router.navigateByUrl('/');
    this.sharedService.triggerClickLogo();
  }
  public clickLogin() {
    this.clickButton('loginBtn');
    this.closeExplainerUntilNextProduct();
  }

  closeMenus() {
    if (this.isUserLogin && this.marketplaceProfileSection?.showProfileMenu) {
      this.marketplaceProfileSection.showProfileMenu = false;
      if (isPlatformBrowser(this.platformId)) {
        document.body.style.overflow = '';
      }
    }
    this.menuSliderLeft = false;
  }

  private getRandom(max) {
    let rnd = Math.random() * max;
    rnd = Math.floor(rnd);
    return rnd;
  }
  public editCurrentProduct() {
    this.sharedService.editProductIdSubject.next(null);
  }
  public selectedMobileAd = null;
  public giggleWiz = false;
  private adChangeTimeout = null;
  public showProductExplainer = false;
  public explainText = '';
  public isExplanationProductClaimable = false;
  public showExplainerParam2 = true;

  public closeExplainerUntilNextProduct() {
    this.showExplainerParam2 = false;
  }

  public isWizardVisisble = true;
  ////////////////////////////////////////////////////////////////
  public isReading = false;
  private nowReadingText = '';

  public pause() {
    const synth = speechSynthesis;

    if (synth.speaking && !synth.paused) {
      console.log('Pausing read');
      speechSynthesis.pause();
      this.isReading = false;
    } else {
      console.log('Cannot pause, either not speaking or already paused');
    }
  }

  public async read(text) {
    const synth = window.speechSynthesis;
    if (synth.speaking && this.nowReadingText != text) {
      await synth.cancel();
    }
    if (synth.speaking && this.nowReadingText === text) {
      await synth.resume();
    }
    this.nowReadingText = text;

    const userAgent = navigator.userAgent;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 1;

    const voices = speechSynthesis.getVoices();

    let voice = null;
    //console.log('userAgent is', userAgent)
    if (
      userAgent.includes('Chrome') &&
      !userAgent.includes('Edg') &&
      !userAgent.includes('OPR') &&
      !userAgent.includes('Brave')
    ) {
      console.log('choosing a device on chrome or edge');
      const cand = voices.find(
        (voice) =>
          voices.find(
            (voice) =>
              voice.name.toLowerCase().includes('moira') ||
              voice.lang === 'en-SG'
          ) ||
          voice.lang == 'en-GB' ||
          voice.name.includes('Female') ||
          (voice.lang.includes('en') && voice.name.includes('Google'))
      );
      if (cand) {
        voice = cand;
      }
      //console.log('Picked voice for chrome ', voice)
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      //console.log('the browser is safari')
      const cand = voices.find((voice) => voice.name.includes('Siri'));
      if (cand) {
        voice = cand;
      }
    } else {
      console.log('browser not clear');
    }
    if (voice) {
      utterance.voice = voice;
    }

    this.isReading = true;
    speechSynthesis.speak(utterance);
    utterance.onend = () => {
      this.isReading = false;
    };
  }
  ///////////////////////////////////////////////////////////////
  public get isMobile(): boolean {
    return window.innerWidth >= 767;
  }

  public get showProductExplanation(): boolean {
    if (this.sharedService.isBrowser()) {
      const url = window.location.href;
      return url.includes('?product=') || url.includes('/product/');
    }
    return false;
  }
  public glowMobileAds = true;
  timeout1: any;
  timeout2: any;
  public showMobileAd() {
    const url = window.location.href;
    const isSeeingProductDetail =
      url.includes('?product=') || url.includes('/product/');

    if (isSeeingProductDetail || this.showProductExplainer) {
      //while product is being explained not mobile ad
      return;
    }

    if (this.mobileAds.length) {
      if (this.adChangeTimeout) {
        clearTimeout(this.adChangeTimeout);
        this.adChangeTimeout = null;
      }
      if (this.selectedMobileAd) {
        this.selectedMobileAd = null;
        return;
      }
      this.selectedMobileAd =
        this.mobileAds[this.getRandom(this.mobileAds.length)];

      this.adChangeTimeout = setTimeout(() => {
        this.selectedMobileAd = null;
      }, 3000);
      this.glowMobileAds = false;
      this.local.clearTimeout(this.timeout1);
      this.timeout1 = setTimeout(() => {
        this.glowMobileAds = true;
      }, 20_000); //glow will stop for 20 sec then return(only for ads)
    } else {
      this.giggleWiz = true;
      const audio = new Audio('../../../../assets/sounds/ouch.m4a');

      audio.play().catch(console.error);

      this.local.clearTimeout(this.timeout2);
      this.timeout2 = setTimeout(() => {
        this.giggleWiz = false;
      }, 2000);
    }
  }

  public get isOnBrowser() {
    return this.sharedService.isBrowser();
  }

  private clickButton(id) {
    const button = document.getElementById(id);
    if (button) {
      button.click();
    } else {
      console.error('button not found!');
    }
  }
  public openRefer() {
    this.clickButton('refer-btn');
  }
  public openAddExperience() {
    this.clickButton('add-experience-btn');
  }

  private showAIExplanationForProductSubscritpion: Subscription | null = null;
  public isPopupOpen = false;
  timeout3: any;
  carouselOptions: any = {
    slidesPerView: 4,
    spaceBetween: 10,
  };

  isAdmin: boolean = false;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.sharedService.openNewUserSurveySubject.subscribe((data = {}) => {
        this._openSurvey(data);
      });
      if (window.location.hostname === 'sgbojio.com') {
        this.sloganText = 'Good things must be Shared';
      }

      if (window.location.hostname === 'brands4good.asia') {
        this.sloganText = 'Grow Your Business With Us';
      }

      //this._setupBasedOnLogin()
      this.fetchMessageAtTop();
      this._getRelationShips();
      this._setupLevelChangeModalSubscription();

      const excludedRoute = [
        'www.fusionapp.store',
        'www.sgbojio.com',
        'www.brands4good.asia',
        'www.ezcart.app',
        'www.corporatepromo.sg',
        'www.combuu.com',
        'www.myvip.asia',
      ];

      if (excludedRoute.includes(window.location.hostname))
        this.seoService.updateNoIndex(true);

      this.route.queryParams.subscribe((params) => {
        const status = params['status'];

        if (status === 'complete') {
          Swal.fire('Added!', 'Card added successfully', 'success');
        } else if (status) {
          Swal.fire('Failed!', 'Operation failed', 'warning');
        }
      });

      this.checkPage();
      this.auth.getAllHomepageAds().subscribe({
        next: (data: any) => {
          this.mobileAds = data.data;
        },
        error: console.error,
      });
      //this.local.fetchUser();
      this.local.getUserDetailsObserver().subscribe((user) => {
        if (!this.sharedService.isBrowser()) {
          return;
        }
        if (user?.id) {
          //console.log(user, "USER SIDEBAR")
          this.referralCode = user.referralCode;
          this.appUserId = user.id;
          this.isUserLogin = 1;
          this.profileAvatar = this.imgUrl + user.profileCharacterImageFile;
          this.local.periodicallyCheckLoginUserData();
          this.store.dispatch(loadUser({}));
          // console.log('user theme is', user.theme)
          // if (user.theme) {
          //   this.commonService.setTheme(user.theme);
          //   this.cdr.markForCheck()
          // }
        } else {
          this.isUserLogin = 0;
          this.openSignInPopupForMobile();
        }
      });

      this.showAIExplanationForProductSubscritpion =
        this.sharedService.showAIExplanationForProductSubject.subscribe(
          (productData) => {
            //console.log({productData})
            this.isPopupOpen = window.location.href.includes('?product=');
            if (productData.closeAll) {
              //this is called when viewproductdetail component is closed
              this.showExplainerParam2 = this.isMobile; //still hide on mobile
              this.showProductExplainer = false;
              this.explainText = '';
              this.cdr.detectChanges();
              return;
            }
            const url = window.location.href;
            this.showProductExplainer =
              url.includes('?product=') || url.includes('/product/'); //never show product explainer if not on product single page or popup is opened
            this.explainText = productData.explainText;
            this.isExplanationProductClaimable =
              productData.isExplanationProductClaimable;
            this.cdr.detectChanges();
          }
        );
      if (
        JSON.parse(localStorage.getItem('tutorials')) ||
        (JSON.parse(localStorage.getItem('tutorials')) === null &&
          this.sharedService.isBrowser())
      ) {
        this.sharedService.shepherd$.subscribe((res: any) => {
          if (res === 'add-product') {
            this.shepherdService.addSteps(
              getStepsAddProduct(this.auth.enableLoader)
            );
            this.shepherdService.start();
          } else if (res === 'verify-email') {
            this.router.navigateByUrl('/advanced-settings').then(() => {
              this.local.clearTimeout(this.timeout3);
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsVerifyEmail);
                this.shepherdService.start();
              }, 100);
            });
          } else if (res === 'new-user') {
            this.router.navigateByUrl('/me/profile').then(() => {
              this.local.clearTimeout(this.timeout3);
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsProfile);
                this.shepherdService.start();
              }, 100);
            });
          } else if (res === 'suggestion-product') {
            this.router.navigateByUrl('/').then(() => {
              this.local.clearTimeout(this.timeout3);
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(
                  stepsSuggestionProduct(this.auth.enableLoader)
                );
                this.shepherdService.start();
              }, 3000);
            });
          } else if (res === 'favorites-product') {
            this.router.navigateByUrl('/').then(() => {
              this.local.clearTimeout(this.timeout3);
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsFavoritesProduct);
                this.shepherdService.start();
              }, 3000);
            });
          } else if (res === 'create-forum') {
          } else if (res === 'answer-forum') {
          } else if (res === 'create-news') {
            this.router.navigateByUrl('/news').then(() => {
              this.local.clearTimeout(this.timeout3);
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsCreateNews);
                this.shepherdService.start();
              }, 1000);
            });
          }
          this.shepherdService.defaultStepOptions = defaultStepOptions;
          this.shepherdService.modal = true;
          this.shepherdService.confirmCancel = false;
        });
      }

      // if (this.sharedService.isBrowser()) {
      //   if (localStorage.getItem('selectedTheme') === 'space') {
      //     document.documentElement.classList.add('space');
      //   } else if (localStorage.getItem('selectedTheme') === 'beige') {
      //     document.documentElement.classList.add('beige');
      //   } else if (localStorage.getItem('selectedTheme') === 'winter') {
      //     document.documentElement.classList.add('winter');
      //   } else if (localStorage.getItem('selectedTheme') === 'bronze') {
      //     document.documentElement.classList.add('bronze');
      //   } else if (localStorage.getItem('selectedTheme') === 'red') {
      //     document.documentElement.classList.add('red');
      //   }
      // }

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.marketplaceProfileSection?.showProfileMenu
            ? (this.marketplaceProfileSection.showProfileMenu = false)
            : '';
          document.body.style.overflow = '';
          this.menuSliderLeft = false;
        }
      });
      this._checkIfUserHasProfileCharacterName();
    }
  }

  public goToGiveAway() {
    this.router.navigate(['giveaway']);
  }

  public openSignInPopupForMobile() {
    // if (window.innerWidth < 768 && this.router.url == '/') {
    //   timer(2000).subscribe(() => {
    //     this.openSigninModal();
    //   });
    // }
  }

  private navigationSubscription: Subscription;

  ngAfterViewInit() {
    // small delay to make sure view is ready
    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.shepherdService.defaultStepOptions?.buttons?.length) {
          this.shepherdService?.complete(); // or use .cancel() if you prefer to cancel the tour
        }
      }
    });
    if (this.sharedService.isBrowser()) {
      this.showExplainerParam2 = this.isMobile;


      this.roleService.rolesSubject.subscribe((roles) => {
        this.isAdmin = roles?.userType?.includes('ADMIN');
        this.cdr.detectChanges();
      });
    }
  }

  ngOnDestroy() {
    // Clean up the subscription when the component is destroyed
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    this.local.clearTimeout(this.timeout1);
    this.local.clearTimeout(this.timeout2);
    this.local.clearTimeout(this.timeout3);
    this.showAIExplanationForProductSubscritpion?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  @ViewChild('sideLeftMenu', { static: false })
  sideLeftMenu: SideLeftMenuComponent;

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (
      this.menuSliderLeft &&
      !this.sideLeftMenu?.sideMenuWrapper?.nativeElement?.contains(event.target)
    ) {
      console.log('closing left side menu');
      this.menuSliderLeft = false;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // if (
    //   (scrollTop > this.lastScrollTop && scrollTop != 0) ||
    //   window.innerHeight + window.scrollY >=
    //   document.documentElement.scrollHeight
    // ) {
    //   console.log('navbarVisible', "false")
    //   this.navbarVisible = false;
    // } else {
    //   console.log('navbarVisible', "true")
    //   this.navbarVisible = true;
    // }
    // console.log('navbarVisible', "check")
    // this.lastScrollTop = scrollTop;
  }

  openProfilePopup(tab) {
    this.marketplaceProfileSection?.tab
      ? (this.marketplaceProfileSection.tab = tab)
      : '';
    if (this.marketplaceProfileSection) {
      this.marketplaceProfileSection.showProfileMenu = true;
    }
    //problem scroll from here
    // if (isPlatformBrowser(this.platformId)) {
    //   document.body.style.overflow = 'hidden';
    // }
  }

  goTo(value: string) {
    this.router.navigate([value]);
  }
  urlPage: string = '/';
  checkPage() {
    this.urlPage = this.router.url;

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.modalService.dismissAll();
        console.log(event.urlAfterRedirects, 'event.urlAfterRedirects');
        this.urlPage = event.urlAfterRedirects; // or event.url if you want the original URL
      });
  }
  openMenuOptionsModal() {
    this.menuOptions.openMenuOptionsModal();
  }
  openShopSignoutPopup(modal) {
    this.modalService.dismissAll();
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'shop_signin_pop',
    });
    // this.router.navigateByUrl('/');
  }
  openLevelUpPopup(modal) {
    this.modalService.dismissAll();
    this.modalService.open(modal, {
      size: 'sm',
      windowClass: 'level-up-popup',
      centered: true,
    });
  }
  modalDismissAll() {
    this.modalService.dismissAll();
  }

  public logout(): void {
    console.log('logging out');
    this.auth
      .logout_customer_marketplace({ id: this.appUserId })
      .subscribe((response: ApiResponse) => {});
    this.modalDismissAll();
    this.toastr.success('Sign out successfully.');
    this.memberNotificationService.clearNotification();
    this.local.logout();
    //this.local.fetchUser();
    //this.router.navigateByUrl('/');
    window.location.reload();
  }

  public openSigninModal(): void {
    this.signIn.loginStage = '';
    this.signIn.openSignInPopup();
  }

  public openCustomizationModal(): void {
    this.modalService.open(CustomizationComponent, {
      size: 'md',
      windowClass: 'customization-modal',
      centered: true,
    });
  }
  // @HostListener('window:beforeunload', ['$event'])
  // whenLeaveSite(event: BeforeUnloadEvent): void {
  //   event.preventDefault();
  //   event.returnValue = 'Do you wish to exit the website?'; // This triggers the default "Are you sure you want to leave?" dialog
  // }
}
